export default "__VITE_ASSET__SQJflx4Q__"